module.exports = __webpack_public_path__ + "static/media/burbuja_der_fondo.3af879e3.png";